/** Backend checkers keys for "business" module */
export enum BusinessCheckerKeysEnum {
  /** Check that deal(s) exists by identifier(s) */
  DEAL_ASSERT_EXISTS_BY_ID = 'business/business-checker-keys.enum::DEAL_ASSERT_EXISTS_BY_ID',
  /** Check that deal(s) exists by DTO(s) */
  DEAL_ASSERT_EXISTS_BY_DTO = 'business/business-checker-keys.enum::DEAL_ASSERT_EXISTS_BY_DTO',
}
